export default "__VITE_ASSET__BY0M_R8W__";